export const capitalizeFirstChar = (text) => text[0]?.toUpperCase() + text.slice(1);
